import { apiFetch } from './http';

/**
 * Client-portal request API (full-live-cutover §2.2). The Support page's
 * change-request form writes REAL PocketBase rows through the Node backend
 * (`client_requests` collection, 1789900012) instead of local state — and
 * every submission is routed (dry-run) to agent_0_orchestrator via the B5
 * jobs queue. Tenant identity travels ONLY in the Bearer token claims
 * (http.js); no client-supplied tenant identifiers here or anywhere.
 */

/** File a new request. Body {subject, body, kind?}; resolves {request}.
 * kind: 'change_request' (default) | 'support' | 'general'. */
export function submitRequest({ subject, body, kind = 'change_request' }) {
  return apiFetch('/api/clients/me/requests', {
    method: 'POST',
    body: JSON.stringify({ subject, body, kind })
  }).then((response) => response?.request ?? response);
}

/** The session tenant's requests, newest first (backend caps at 50). */
export function fetchMyRequests() {
  return apiFetch('/api/clients/me/requests');
}

/** Cancel one of the session tenant's own pending requests (submitted or
 * routed). Cross-tenant ids are 404 server-side — same contract as approvals. */
export function cancelRequest(id) {
  return apiFetch(`/api/clients/me/requests/${id}`, {
    method: 'PATCH',
    body: JSON.stringify({ action: 'cancelled' })
  }).then((response) => response?.request ?? response);
}
